import * as React from "react";
import { connect } from 'react-redux';
import { ApplicationState } from "../../../store";
import { AppServices } from "../../../AppServices";

interface SdsInstructionBannerProps {
    fileList?: Array<{ type: string; filename: string }> | null;
    pageType: 'ProductOverview' | 'BomEditor';
    appServices?: AppServices | null;
}

/**
 * Reusable component to display SDS (Safety Data Sheet) file upload instructions
 * Shows different alert styles based on whether an SDS file has been uploaded
 */
const SdsInstructionBannerComponent: React.FC<SdsInstructionBannerProps> = ({ 
    fileList, 
    pageType,
    appServices
}) => {
    const sdsFiles = fileList?.filter(file => file.type === "InventoryMsdsFile") || [];
    const hasSdsFile = sdsFiles.length > 0;
    const fileName = hasSdsFile ? sdsFiles[0].filename : "";

    const localizeString = (key: string) => appServices?.localizeString(key) || key;

    // Get localized text based on page type
    const instructionText = pageType === 'ProductOverview'
        ? localizeString("Your requestor requires you to submit a SDS file for this product. Please provide the SDS using the Import button on this page, or on the Ingredient Disclosure Data page.")
        : localizeString("Your requestor requires you to submit a SDS file for this product. Please provide the SDS using the Import button on this page, or on the previous product overview page.");

    const uploadedFileLabel = localizeString("Uploaded SDS file:");

    // Determine alert style based on upload status
    const alertClass = hasSdsFile ? "alert alert-success" : "alert alert-info";
    const iconClass = hasSdsFile ? "glyphicon-ok" : "glyphicon-info-sign";

    return (
        <div className={`sds-instruction-banner ${alertClass} m-b-15`}>
            <div className="banner-content">
                <span 
                    className={`glyphicon ${iconClass}`} 
                    aria-hidden="true" 
                    style={{ marginRight: '10px' }}
                />
                <div className="banner-text">
                    <p>{instructionText}</p>
                    {hasSdsFile && (
                        <p className="uploaded-file-text" style={{ fontWeight: 'bold', marginTop: '5px' }}>
                            {uploadedFileLabel} {fileName}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const SdsInstructionBanner = connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(SdsInstructionBannerComponent);
